import { RegistrationState } from "../auth/RegistrationState";

const IF = require( "infrontjs" );

import template from './PaymentWallTemplate.html';
import { IndexState } from "../index/IndexState";
import { LoginState } from "../auth/LoginState";

import './../../components/general/main-menu';
import './../../components/general/header-bar';
import { PaInfoState } from "./PaInfoState";

export class PaymentWallState extends IF.State
{
    static ROUTE = '/payment-wall';
    static ID = 'payment-wall';

    canEnter()
    {
        if ( this.app.currentUser && false === this.app.currentUser.isPaying() && false === this.app.isNativeMobile() )
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    getRedirectUrl()
    {
        if ( null === this.app.currentUser )
        {
            return LoginState.ROUTE;
        }
        else
        {
            if ( false === this.app.currentUser.isPaying() && true === this.app.isNativeMobile() )
            {
                return PaInfoState.ROUTE;
            }
            else
            {
                return IndexState.ROUTE;
            }
        }
    }

    async enter()
    {
        let paymentData = null;
        const pdRes = await this.app.api.get( '/payment/data' );
        if ( pdRes && 200 === pdRes.status )
        {
            paymentData = await pdRes.json();
        }

        const motivationPlans = paymentData.prices.motivation;
        const membershipPlans = paymentData.prices.membership;

        this.app.container.innerHTML = this.app.view.getHtml(
            template,
            {
                motivationPlans : motivationPlans,
                membershipPlans : membershipPlans,
                currentUser : this.app.currentUser
            }
        );

        const scriptElem = document.createElement( "script" );
        scriptElem.setAttribute( "src", "https://www.paypal.com/sdk/js?client-id=" + paymentData.paypalClientId + "&vault=true&intent=subscription");
        scriptElem.setAttribute( "data-sdk-integration-sourc", "integrationbuilder_sc" );
        scriptElem.addEventListener( "load", () =>
        {
            this.initPayPalMembershipButton();
            this.initPayPalMotivationButton()
        });

        this.app.container.appendChild( scriptElem );

        this.app.container.querySelectorAll( '[data-type="membership-payment-option"]' ).forEach( ( div ) =>
        {
            div.addEventListener( 'click', ( e ) => {
                this.app.container.querySelector( '.plan-selected[data-type="membership-payment-option"]' ).classList.remove( 'plan-selected' );
                e.currentTarget.classList.add( 'plan-selected' );
            });
        });

        this.app.container.querySelectorAll( '[data-type="motivation-payment-option"]' ).forEach( ( div ) =>
        {
            div.addEventListener( 'click', ( e ) => {
                this.app.container.querySelector( '.plan-selected[data-type="motivation-payment-option"]' ).classList.remove( 'plan-selected' );
                e.currentTarget.classList.add( 'plan-selected' );
            });
        });

        //const rabattToReplacePackage = this.app.container.querySelector( '[data-plan-type="normal-monthly"]' );
        const fibo24 = this.app.container.querySelector( '[data-plan-type="fibo-special-fibo24"]' );
        const fiboPreis = this.app.container.querySelector( '[data-plan-type="fibo-special-preis"]' );
        const rabattStartNow = this.app.container.querySelector( '[data-plan-type="rabatt-startnow"]' );
        const rabattDayOne = this.app.container.querySelector( '[data-plan-type="rabatt-dayone"]' );
        const rabattPowerUp = this.app.container.querySelector( '[data-plan-type="rabatt-powerup"]' );
        const rabattMeinGym = this.app.container.querySelector( '[data-plan-type="rabatt-meingym"]' );
        this.app.container.querySelector( '[data-id="input-rabattcode"]').addEventListener( 'keyup', ( e ) =>
        {
            const rabattCode = e.currentTarget.value.toUpperCase();
            if ( rabattCode === 'STARTNOW' )
            {
                //rabattToReplacePackage.classList.add( 'hidden' );
                rabattStartNow.classList.remove( 'hidden' );
                rabattStartNow.click();
                e.currentTarget.blur();
            }
            else if ( rabattCode === 'DAYONE' )
            {
                //rabattToReplacePackage.classList.add( 'hidden' );
                rabattDayOne.classList.remove( 'hidden' );
                rabattDayOne.click();
                e.currentTarget.blur();
            }
            else if ( rabattCode === 'POWERUP' )
            {
                //rabattToReplacePackage.classList.add( 'hidden' );
                rabattPowerUp.classList.remove( 'hidden' );
                rabattPowerUp.click();
                e.currentTarget.blur();
            }
            else if ( rabattCode === 'MEINGYM' )
            {
                //rabattToReplacePackage.classList.add( 'hidden' );
                rabattMeinGym.classList.remove( 'hidden' );
                rabattMeinGym.click();
                e.currentTarget.blur();
            }
            else
            {
                rabattStartNow.classList.add( 'hidden' );
                rabattDayOne.classList.add( 'hidden' );
                rabattPowerUp.classList.add( 'hidden' );
                rabattMeinGym.classList.add( 'hidden' );

                //fibo24.classList.add( 'hidden' );
                //fiboPreis.classList.add( 'hidden' );
                //rabattToReplacePackage.classList.remove( 'hidden' );
                //rabattToReplacePackage.click();
            }
        });
    }

    async exit()
    {
    }

    initPayPalMembershipButton()
    {
        const self = this;

        window.paypal
            .Buttons({
                style: {
                    shape: 'pill',
                    color: 'gold',
                    layout: 'vertical',
                    label: 'subscribe'
                },
                async createSubscription() {
                    try {
                        const response = await self.app.api.post(
                            '/payment/subscription',
                            {
                                userAction: "SUBSCRIBE_NOW",
                                planId : self.app.container.querySelector('.plan-selected[data-type="membership-payment-option"]' ).getAttribute( 'data-plan-id' )
                            }
                        );

                        const data = await response.json();
                        if ( data?.id )
                        {
                            return data.id;
                        }
                        else
                        {
                            self.app.gui.showSnackbarError( "Entschuldige. PayPal kann derzeit nicht initiiert werden." );
                        }
                    }
                    catch (error)
                    {
                        self.app.gui.showSnackbarError( "Entschuldige. Es ist ein Fehler bei der PayPal Kommunikation aufgetreten." );
                    }
                },
                async onApprove(data) {
                    /*
                      No need to activate manually since SUBSCRIBE_NOW is being used.
                      Learn how to handle other user actions from our docs:
                      https://developer.paypal.com/docs/api/subscriptions/v1/#subscriptions_create
                    */
                    if ( data.orderID )
                    {

                        const response = await self.app.api.put(
                            '/payment/subscription/approve',
                            data
                        );

                        if ( 200 === response.status )
                        {
                            const responseBody = await response.json();
                            self.app.currentUser.setData( 'membershipPlanId', responseBody.subscriptionPlanId );
                        }

                        self.app.gui.showSnackbarConfirmed( "Abo erfolgreich ausgewählt." );
                        self.app.container.querySelector( '[data-id="section-membership"]' ).classList.add( 'hidden' );
                        self.app.container.querySelector( '[data-id="section-motivation"]' ).classList.remove( 'hidden' );
                    }
                    else
                    {
                        self.app.gui.showSnackbarError( "Fehler. Aktivierung des Abos ist fehlgeschlagen. " );
                    }
                },
            })
            .render("#paypal-button-container-membership");
    }

    initPayPalMotivationButton()
    {
        const self = this;

        window.paypal
            .Buttons({
                style: {
                    shape: 'pill',
                    color: 'gold',
                    layout: 'vertical',
                    label: 'subscribe'
                },
                async createSubscription() {

                    try {
                        const response = await self.app.api.post(
                            '/payment/subscription',
                            {
                                userAction: "SUBSCRIBE_NOW",
                                planId : self.app.container.querySelector('.plan-selected[data-type="motivation-payment-option"]' ).getAttribute( 'data-plan-id' )
                            }
                        );

                        const data = await response.json();
                        if ( data?.id )
                        {
                            return data.id;
                        }
                        else
                        {
                            self.app.gui.showSnackbarError( "Entschuldige. PayPal kann derzeit nicht initiiert werden." );
                        }
                    }
                    catch (error)
                    {
                        self.app.gui.showSnackbarError( "Entschuldige. Es ist ein Fehler bei der PayPal Kommunikation aufgetreten." );
                    }
                },
                async onApprove( data ) {
                    /*
                      No need to activate manually since SUBSCRIBE_NOW is being used.
                      Learn how to handle other user actions from our docs:
                      https://developer.paypal.com/docs/api/subscriptions/v1/#subscriptions_create
                    */
                    if ( data.orderID )
                    {

                        const response = await self.app.api.put(
                            '/payment/subscription/approve',
                            data
                        );

                        if ( 200 === response.status )
                        {
                            const responseBody = await response.json();
                            self.app.currentUser.setData( 'motivationBonusPlanId', responseBody.subscriptionPlanId );
                        }

                        self.app.gui.showSnackbarConfirmed( "Bezahlung erfolgreich abgeschlossen." );

                        setTimeout( () => {
                            window.location.reload();
                        }, 500 );
                    }
                    else
                    {
                        self.app.gui.showSnackbarError( "Fehler. Aktivierung des Abos ist fehlgeschlagen. " );
                    }
                },
            })
            .render("#paypal-button-container-motivation");
    }
};
